import { transmission } from "../../../utils/config";

const useVehicleClassesLogic = () => {
  const apiRoute = "vehicleclasses";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Vehicle class name",
      type: "text",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Vehicle class name is required",
    },
    {
      name: "title",
      label: "Vehicle class display name",
      type: "text",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Vehicle class display name is required",
    },
    {
      name: "frontend_displays",
      label: "Frontend displays",
      type: "card",
      apiUrl: "vehicleclassesfrontend",
      parentParam: "class",
      isRequired: false,
      err: "Frontend displays are required",
      span: 1,
      headerAction: {
        name: "Add",
        id: "add",
      },
      inputField: {
        name: "order",
        type: "number",
        minValue: 1,
        label: "<s>Order",
      },
      toShow: {
        title: "name",
        id: "id",
        tempid: "tempid",
        status: "",
        createdBy: "",
        createdOn: "",
        inputValue: "order",
        delete: "delete",
        description: "<s>ID: , ,id",
      },
      rowActions: [
        {
          name: "Edit",
          id: "edit",
        },
        {
          name: "Delete",
          id: "update",
          data: {
            delete: true,
          },
        },
      ],
      rowActionsShowNew: true,
      exclude: {
        name: "delete",
        value: true,
      },
      formOptions: {
        label: "Add New Frontend Display",
        fields: [
          {
            name: "name",
            label: "Name",
            type: "text",
            isRequired: true,
            err: "Name is required",
            span: 3,
          },
          {
            name: "seats",
            label: "Seats",
            type: "number",
            isRequired: true,
            err: "Seats is required",
            span: 3,
            minValue: 1,
          },
          {
            name: "doors",
            label: "Doors",
            type: "number",
            minValue: 0,
            isRequired: true,
            err: "Doors is required",
            span: 3,
          },
          {
            name: "transmission",
            label: "Transmission",
            type: "dropdown",
            isRequired: true,
            err: "Transmission is required",
            data: transmission,
            span: 3,
          },
          {
            name: "image",
            label: "Image",
            type: "file",
            isRequired: false,
            err: "Image is required",
            isMulti: false,
            span: 3,
          },
          {
            name: "order",
            label: "Order",
            type: "number",
            minValue: 1,
            isRequired: true,
            err: "Order is required",
            span: 3,
          },
          {
            name: "enable_frontend",
            label: "Show on frontend?",
            type: "toggle",
            isRequired: false,
            err: "Show on frontend? is required",
            span: 3,
          },
          {
            name: "offer_image",
            label: "Offer's image",
            type: "file",
            isRequired: false,
            err: "Offer's image is required",
            isMulti: false,
            span: 3,
          },
          {
            name: "offer_image_mb",
            label: "Offer's image mobile",
            type: "file",
            isRequired: false,
            err: "Offer's image mobile is required",
            isMulti: false,
            span: 3,
          },
        ],
      },
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const FinanceRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, FinanceRole, managerRole];
  const deleteRoles = [admin, FinanceRole, managerRole];
  const editRoles = [admin, FinanceRole, managerRole];

  const getPromises = (temp) => {
    return [];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useVehicleClassesLogic;
